import React, { useState } from "react";
import Images from "../../../asstes";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useNavigate } from "react-router";
import { useQuery } from "react-query";
import { getViewCustomer } from "../Api/GlobalApi";
const UploadViewCustomer = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const [filter, setFilter] = useState(null);
  const [filterState, setFilterState] = useState(null);

  const { data, isLoading, isError, refetch } = useQuery(
    "getViewCustomer",
    getViewCustomer
  );
  let details = (data && data?.data) || [];

  const filteredData = details
    ? details?.filter((item) => {
        const matchesSearchTerm =
          item?.clientName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item?.companyName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          String(item?.phoneNumber)
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          String(item?.location)
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          String(item?.address)
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase());

        const matchesFilter = !filter || item?.feedback === filter; // Assuming filterType exists on items

        const matchesFilterState = !filterState || item?.status === filterState; // Assuming status exists on items

        return matchesSearchTerm && matchesFilter && matchesFilterState;
      })
    : [];

  const downloadExcel = () => {
    // Prepare empty data if there's no valid data to export
    const exportData =
      filteredData && filteredData?.length > 0 ? filteredData : filteredData;

    const tableDatas =
      exportData && exportData?.length > 0
        ? exportData?.map((data, index) => ({
            "S.NO": index + 1,
            "COMPANY NAME": data?.companyName || null,
            "CLIENT NAME": data?.clientName || null,
            ADDRESS: data?.address || null,
            "MOBILE NUMBER": data?.phoneNumber || null,
            LOCATION: data?.location || null,
            STATE: data?.state || null,
          }))
        : []; // Default to an empty array

    // Create a new workbook and add an empty sheet if there's no data
    const workbook = XLSX.utils.book_new();
    const tableWorksheet = XLSX.utils.json_to_sheet(
      tableDatas?.length > 0 ? tableDatas : [{}],
      {
        skipHeader: false,
      }
    );

    // Optionally set headers even if no data
    if (tableDatas?.length === 0) {
      XLSX.utils.sheet_add_aoa(tableWorksheet, [
        [
          "S.NO",
          "REGISTER NUMBER",
          "STUDENT NAME",
          "COLLEGE NAME",
          "COURSE",
          "MOBILE NUMBER",
          "ALTENATE NUMBER",
          "AADHAR NUMBER",
          "DATE OF BIRTH",
          "CITY",
          "PINCODE",
          "DATE OF JOINING",
          "DATE OF RELIEVING",
        ],
      ]);
    }

    XLSX.utils.book_append_sheet(workbook, tableWorksheet, "Table Data");

    // Generate the Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Save the Excel file
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "View Customer.xlsx");
  };

  // Dashboard calculation
  let totalcalls = filteredData?.length || 0;
  let responded = 0;
  let interestedCount = 0;
  let notInterestedCount = 0;
  let callbackCount = 0;

  filteredData?.forEach((d) => {
    if (
      d?.feedback === "Callback" ||
      d?.feedback === "Interested" ||
      d?.feedback === "Not Interested"
    ) {
      responded += 1;

      if (d?.feedback === "Interested") {
        interestedCount += 1;
      } else if (d?.feedback === "Not Interested") {
        notInterestedCount += 1;
      } else if (d?.feedback === "Callback") {
        callbackCount += 1;
      }
    }
  });
  let rnrBcNrCount = 0;
  let invSwoWrnRbcCount = 0;

  filteredData?.forEach((d) => {
    if (d?.status === "RNR/BC/NR") {
      rnrBcNrCount += 1;
    } else if (d?.status === "INV/SWO/WRN/RBC") {
      invSwoWrnRbcCount += 1;
    }
  });

  // status chanegw

  const handleFeedbackChange = (e, data) => {
    const selectedValue = e.target.value;
    navigate("/editUploadCustomer", {
      state: {
        ...data,
        feedback: selectedValue,
      },
    });
  };

  const handleStatusChange = (e, rowData) => {
    const selectedStatus = e.target.value;
    navigate("/editUploadCustomer", {
      state: {
        ...rowData,
        status: selectedStatus,
      },
    });
  };

  return (
    <>
      <div className="row d-flex align-items-center mt-3 mb-2 px-3">
        <div className="col-lg-6">
          <div className="view_customer_search">
            <input
              type="search"
              className="search-box"
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="search by company, name, number , location"
              title="search by company, name, number , location"
            />
            <div className="image-icon">
              <img
                src={Images?.searchIcon}
                alt="No-Image"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-6  d-flex justify-content-end gap-2">
          <select
            className="view_customer_filter"
            onChange={(e) => {
              setFilter(e.target.value);
            }}
          >
            <option value="" selected>
              Filter
            </option>

            <option value="Interested">Interested</option>
            <option value="Not Interested">Not Interested</option>
            <option value="Callback">Callback</option>
          </select>
          <select
            className="view_customer_filter"
            onChange={(e) => {
              setFilterState(e.target.value);
            }}
          >
            <option value="" selected>
              Status
            </option>
            <option value="RNR/BC/NR">RNR/BC/NR</option>
            <option value="INV/SWO/WRN/RBC">INV/SWO/WRN/RBC</option>
          </select>
          <div className="download-icon">
            <img
              src={Images?.downloadIcon}
              width="100%"
              height="100%"
              alt="No-Image"
              onClick={() => {
                downloadExcel();
              }}
            />
          </div>
        </div>
      </div>
      <div className="row my-2 d-flex justify-content-center">
        <div className="col-12 col-sm-6 col-lg-1 dashborad-card-block --first-block">
          <span className="dashboard-heading">Total Calls</span>
          <span className="dashboard-value">{totalcalls || 0}</span>
        </div>
        <div className="col-12 col-sm-6  col-lg-1 dashborad-card-block ">
          <span className="dashboard-heading">Responded</span>
          <span className="dashboard-value">{responded || 0}</span>
        </div>
        <div className="col-12 col-sm-6  col-lg-1 dashborad-card-block">
          <span className="dashboard-heading">Callback</span>
          <span className="dashboard-value">{callbackCount || 0}</span>
        </div>
        <div className="col-12 col-sm-6 col-lg-1 dashborad-card-block">
          <span className="dashboard-heading">Interested</span>
          <span className="dashboard-value">{interestedCount || 0}</span>
        </div>
        <div className="col-12 col-sm-6  col-lg-2 dashborad-card-block">
          <span className="dashboard-heading">Not Interested</span>
          <span className="dashboard-value">{notInterestedCount || 0}</span>
        </div>
        <div className="col-12 col-sm-6  col-lg-1 dashborad-card-block">
          <span className="dashboard-heading">RNR/BC/NR</span>
          <span className="dashboard-value">{rnrBcNrCount || 0}</span>
        </div>
        <div className="col-12 col-sm-6  col-lg-2 dashborad-card-block --last-block">
          <span className="dashboard-heading">INV/SWO/WRN/RBC</span>
          <span className="dashboard-value">{invSwoWrnRbcCount || 0}</span>
        </div>
      </div>

      <div className="view-customer-table-container mx-3 my-2">
        <div className="view-customer-table-block">
          <table className="studetailstable" style={{ width: "100%" }}>
            <thead>
              <tr>
                <th className="viewcustomerheader sticky_header_first">
                  SELECT
                </th>
                <th className="viewcustomerheader sticky_header_second">
                  S.NO
                </th>
                <th className="viewcustomerheader">COMPANY NAME</th>
                <th className="viewcustomerheader">NAME</th>

                <th className="viewcustomerheader">MOBILE NUMBER</th>
                <th className="viewcustomerheader">FEEDBACK</th>
                <th className="viewcustomerheader">STATUS</th>

                <th className="viewcustomerheader">LOCATION</th>
                <th className="viewcustomerheader">STATE</th>
                <th className="viewcustomerheader">BASE NAME</th>

                <th className="viewcustomerheader">DATE</th>
                <th className="viewcustomerheader">ADDRESS</th>
                <th className="viewcustomerheader">ASSIGNTO</th>
                {/* <th className="viewcustomerheader">TELECALLERNUMBER</th> */}
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <>
                  <h5 style={{ width: "200%" }} className="my-2">
                    L O A D I N G ...
                  </h5>
                </>
              ) : filteredData?.length > 0 ? (
                filteredData?.map((data, index) => {
                  return (
                    <>
                      <tr key={index}>
                        <td className="viewcustomerdata sticky_data_first">
                          <div className="d-flex align-items-center justify-content-center gap-1">
                            <input
                              type="checkbox"
                              style={{
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                            />
                            <button
                              style={{
                                cursor: "pointer",
                                border: "none",
                                background: "transparent",
                              }}
                              title="Edit"
                              onClick={() => {
                                navigate("/editUploadCustomer", {
                                  state: data,
                                });
                              }}
                            >
                              ✏️
                            </button>
                          </div>
                        </td>
                        <td className="viewcustomerdata sticky_data_second">
                          {index + 1 || "-"}
                        </td>
                        <td className="viewcustomerdata">
                          {data?.companyName || "-"}
                        </td>
                        <td className="viewcustomerdata">
                          {data?.clientName || "-"}
                        </td>

                        <td className="viewcustomerdata">
                          {data?.phoneNumber || "-"}
                        </td>
                        <td className="viewcustomerdata">
                          {/* {data?.feedback || "-"} */}
                          <select
                            style={{
                              height: "30px",
                              cursor: "pointer",
                              borderRadius: "8px",
                            }}
                            name="feedback"
                            onChange={(e) => {
                              handleFeedbackChange(e, data);
                            }}
                            defaultValue={data?.feedback || filter || ""}
                          >
                            <option value="" selected>
                              Feedback
                            </option>
                            <option value="Interested">Interested</option>
                            <option value="Not Interested">
                              Not Interested
                            </option>
                            <option value="Callback">Callback</option>
                          </select>
                        </td>
                        <td className="viewcustomerdata">
                          <select
                            style={{
                              height: "30px",
                              cursor: "pointer",
                              borderRadius: "8px",
                            }}
                            defaultValue={data?.status || filterState || ""}
                            onChange={(e) => handleStatusChange(e, data)}
                          >
                            <option value="">Select Status</option>
                            <option value="RNR/BC/NR">RNR/BC/NR</option>
                            <option value="INV/SWO/WRN/RBC">
                              INV/SWO/WRN/RBC
                            </option>
                          </select>
                        </td>

                        <td className="viewcustomerdata">
                          {data?.location || "-"}
                        </td>
                        <td className="viewcustomerdata">
                          {data?.state || "-"}
                        </td>
                        <td className="viewcustomerdata">
                          {data?.baseName || "-"}
                        </td>

                        <td className="viewcustomerdata">
                          {data?.date || "-"}
                        </td>
                        <td className="viewcustomerdata">
                          {data?.address || "-"}
                        </td>

                        <td className="viewcustomerdata">
                          {data?.assignTo || "-"}
                        </td>

                        {/* <td className="viewcustomerdata">
                          {data?.telecallernumber}
                        </td> */}
                      </tr>
                    </>
                  );
                })
              ) : (
                <>
                  <tr>
                    <h5 className="my-3 mx-0" style={{ width: "200%" }}>
                      NO RECORDS FOUNDS
                    </h5>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default UploadViewCustomer;
